import { WifiOff } from 'lucide-react';
import './ConnectionLost.css';

/**
 * What is drawn in place of a screen whose contents never arrived.
 *
 * The app used to have three of these moments and drew nothing at all in every
 * one of them: an empty surface while the session check was in flight, an empty
 * chat list when the list request failed, an empty thread when a conversation's
 * messages did. All three were silent by design — «offline: keep what is on
 * screen and retry on reconnect» is the right instinct — and all three are that
 * instinct applied to a device that has nothing on screen yet, where what it
 * keeps is a blank rectangle.
 *
 * So this says the one thing a person on a bad mobile network cannot work out
 * for themselves, and gives them the one action the app otherwise reserved for
 * a socket reconnect it might never make.
 *
 * It fills whatever it is put in rather than positioning itself, which is what
 * lets the same component be the whole app behind a login and one pane beside a
 * chat list.
 */
export function ConnectionLost({
  text = 'Нет связи с сервером',
  busy = false,
  onRetry,
}: {
  text?: string;
  /** A retry is in flight; the button says so rather than looking unpressed. */
  busy?: boolean;
  onRetry: () => void;
}) {
  return (
    <div className="connection-lost" role="status">
      <WifiOff className="connection-lost-icon" size={32} />
      <div className="connection-lost-text">{text}</div>
      <button className="connection-lost-button" type="button" onClick={onRetry} disabled={busy}>
        {busy ? 'Пробуем…' : 'Повторить'}
      </button>
    </div>
  );
}
